import { createFileRoute } from '@tanstack/react-router'
import { BoxIcon } from 'lucide-react'

export const Route = createFileRoute('/_auth/_modules/_app/materials')({
  staticData: {
    title: 'route.materials',
    crumb: 'route.materials',
    icon: BoxIcon,
  },
  beforeLoad: async ({ context }) => {
    context.handleRoutePermissions(Route)
  },
})
